import { Center, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { General } from "./components/General";
import { ScopeOne } from "./components/ScopeOne";
import { ScopeTwo } from "./components/ScopeTwo";
import { ScopeThree } from "./components/ScopeThree";
import * as React from "react";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { BlockHeader } from "../../../../components/BlockHeader";

function Revenue({ data, submitAndReturnToList, setSubmitAndReturnToList, handleNavigationToList, isPreview }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierQuestionnaire"
  });
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Fragment>
      <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex}>
        <Center>
          <TabList borderBottom="none">
            <Tab isDisabled={isPreview ? false : tabIndex !== 0}
                 _focus={{ boxShadow: "none" }}>{t("revenueTabs.general")}</Tab>
            <Tab isDisabled={isPreview ? false : tabIndex !== 1}
                 _focus={{ boxShadow: "none" }} marginInline={8}>{`${t("revenueTabs.scope")} 1`}</Tab>
            <Tab isDisabled={isPreview ? false : tabIndex !== 2}
                 _focus={{ boxShadow: "none" }} marginInline={8}>{`${t("revenueTabs.scope")} 2`}</Tab>
            <Tab isDisabled={isPreview ? false : tabIndex !== 3}
                 _focus={{ boxShadow: "none" }} marginInline={8}>{`${t("revenueTabs.scope")} 3`}</Tab>
          </TabList>
        </Center>
        <TabPanels>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader title={t("general.title")} description={t("general.subtitle")} paddingBottom={8} />
              <General
                isTabActive={tabIndex === 0}
                defaultValues={data}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader title={t("scopeOne.title")} description={t("scopeOne.subtitle")} paddingBottom={8} />
              <ScopeOne
                isTabActive={tabIndex === 1}
                defaultValues={data}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader title={t("scopeTwo.title")} description={t("scopeTwo.subtitle")} paddingBottom={8} />
              <ScopeTwo
                isTabActive={tabIndex === 2}
                defaultValues={data}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader title={t("scopeThree.title")} description={t("scopeThree.subtitle")} paddingBottom={8} />
              <ScopeThree
                isTabActive={tabIndex === 3}
                id={data.id}
                categories={data.revenue?.categories ?? {}}
                questionnaireType={data.questionnaireType}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Fragment>
  );
}

export default Revenue;